// English strings for P6-B (SHIPPING-03/04/05/08, ORDER-06/08/09, RISK-01/03/04) (D-013: English only). Owned by that worker;
// spread into `en` as `en.fulfilment`, so keys read `t("fulfilment.…")`. Copy rules: DESIGN_SYSTEM §9.6.
export const fulfilmentStrings = {
  common: {
    refresh: "Refresh",
    open: "Open",
    save: "Save",
    cancel: "Cancel",
    remove: "Remove",
    close: "Close",
    none: "None",
    working: "Working…",
    openDocument: "Open printable document",
    pdfPending:
      "Saving documents on the server needs the Paid plan (pending activation). Use your browser's Print to save a copy.",
    order: "Order #{number}",
    print: "Print",
    printing: "Preparing to print…",
    printFailed: "The document could not be made. Try again.",
    printSlow: "The document is taking long. Try again in a minute.",
    downloaded: "Export downloaded",
  },
  errors: {
    generic: "That didn't work. Try again.",
    cancelAtCourier:
      "This courier has no cancel option in its API. Cancel the parcel with the courier; its status updates here automatically.",
    courierRefused:
      "The courier refused these details. Check the API key, login and pickup point, then try again.",
    courierUnreachable:
      "The courier is not answering right now. Try saving again in a few minutes.",
    courierInactive:
      "This courier account is not ready. Finish its setup in Apps → Courier accounts.",
    unknownBranch:
      "That is not a Nepal Can Move branch name. Check the spelling in your NCM portal.",
    noCourier: "Connect a courier to book deliveries from here.",
    noCourierForArea: "No connected courier delivers to this area.",
    notReady: "Confirm the order before booking a courier.",
    addressMissing: "The order has no delivery address.",
    specRequired: "This courier can't book yet: we are waiting for its API specification.",
    damagedNotRestocked: "Damaged items are never put back in stock.",
    refundTooHigh: "The refund for an item can be at most what was paid for it.",
    returnQty: "That many items can't be returned from this order.",
    notReturnable: "Only shipped or delivered orders can be returned.",
    notPaid: "A receipt needs a payment on the order.",
    cancelTooLate: "The courier already has this parcel, so it can't be cancelled here.",
    portalPassword: "Adyvance never stores courier portal passwords. Use the courier's API token.",
    vaultPending: "Saving credentials needs the credential vault, which is not connected yet.",
    refundsPending: "Refunds need the payments module, which is not connected yet.",
  },
  shipmentState: {
    draft: "Booking",
    booked: "Booked",
    picked_up: "Picked up",
    in_transit: "In transit",
    out_for_delivery: "Out for delivery",
    delivered: "Delivered",
    failed_attempt: "Delivery failed",
    rto: "Returning to you",
    cancelled: "Cancelled",
  },
  dispatch: {
    title: "Dispatch",
    lead: "Book couriers for confirmed orders, print pick lists, packing slips and labels, and follow parcels.",
    toBookTitle: "To book",
    toBookCaption: "Confirmed orders waiting for a courier",
    toBookEmptyTitle: "Nothing to book",
    toBookEmptyBody: "Confirmed orders appear here until a courier is booked.",
    selected: "{count} selected",
    book: "Book courier",
    pickList: "Pick list",
    packingSlips: "Packing slips",
    printOrders: "Print orders",
    invoices: "Invoices",
    export: "Export spreadsheet (.csv)",
    booked: "{accepted} of {requested} booked",
    bookFailed: "{failed} could not be booked",
    jobQueued: "Preparing the document…",
    jobDone: "The document is ready.",
    jobFailed: "The document could not be prepared.",
    shipmentsTitle: "Parcels",
    shipmentsCaption: "Parcels with couriers",
    shipmentsEmptyTitle: "No parcels yet",
    shipmentsEmptyBody: "Booked parcels and their tracking appear here.",
    columns: {
      order: "Order",
      customer: "Customer",
      area: "Area",
      total: "Total",
      due: "COD",
      courier: "Courier",
      tracking: "Tracking",
      state: "Status",
      updated: "Updated",
    },
    label: "Label",
    pickup: "Request pickup",
    cancelParcel: "Cancel",
    cancelTitle: "Cancel parcel {tracking}?",
    cancelBody: "The courier booking is cancelled. You can submit the order to logistics again.",
    cancelConfirm: "Cancel parcel",
    keepParcel: "Keep parcel",
    pickupRequested: "Pickup requested",
    cancelled: "Parcel cancelled",
    simulated: "Test courier: simulated, never a real delivery.",
    testCourier: "Test courier",
    connectCourier: "Connect courier",
  },
  couriers: {
    names: {
      pathao: "Pathao Parcel",
      ncm: "Nepal Can Move",
      upaya: "Upaya",
      pickndrop: "Pick & Drop",
      hello_service: "Hello Service Nepal",
      daraz: "Daraz Express (DEX)",
    },
    ui: {
      status: {
        ready: "Ready to book",
        setup: "Finish setup",
        saved: "Keys saved",
        notConnected: "Not connected",
        paused: "Paused",
        daraz: "Waiting for Daraz",
        soon: "Coming soon",
      },
      line: {
        stub: "Practise booking with a simulated courier. Never a real delivery.",
        ready: "Books parcels and checks their status every 30 minutes.",
        setup: "Add the API key and pickup point to start booking.",
        setupPathao: "Add your Pathao keys and login to start booking.",
        spec: "Save your keys now. Booking opens when {name} shares its booking API with us.",
        specSaved: "Keys saved. Booking opens when {name} shares its booking API with us.",
        daraz: "Connect with your Daraz seller account. Opens once Daraz approves Adyvance.",
        paused: "Turned off. Your keys stay saved.",
      },
      tiles: {
        connected: "Couriers connected",
        ready: "Ready to book",
        rules: "Routing rules",
        none: "None yet",
        allAreas: "Covers every area",
        defaultCourier: "Default courier",
        defaultAuto: "Automatic",
        defaultHelp: "Used when more than one courier delivers to the address.",
        defaultSaved: "Default courier saved.",
      },
      connect: "Connect {name}",
      settings: "Settings",
      check: "Test connection",
      checking: "Testing…",
      checkOk: "{name} accepted your saved keys.",
      checkFailed: "{name} did not accept your saved keys. Paste a new token and save.",
      checkBranch: "The keys work, but {branch} is not one of the courier's branches.",
      close: "Close",
      cancel: "Cancel",
      save: "Save",
      account: "Account",
      live: "Live",
      test: "Courier sandbox",
      use: "Use for orders",
      useHelp: "Turn off to stop booking with this courier. Your keys stay saved.",
      specTitle: "Booking opens soon",
      specBody:
        "{name} hasn't shared its booking API with us yet. Save your keys now: they are encrypted, and booking turns on as soon as the connection is added.",
      darazTitle: "Connect with Daraz",
      darazBody:
        "You sign in with your Daraz seller account; nothing to copy. This opens once Daraz approves Adyvance's app.",
      darazButton: "Connect with Daraz",
      darazWhy: "Waiting for Daraz to approve Adyvance",
      keys: "API keys",
      keysHelp: "Encrypted and write-only: after saving you only see the last 4 characters.",
      storedEnds: "Saved · ends in {last4}",
      pickup: "Pickup point",
      pickupHelp: "Your pickup branch or address code at the courier.",
      where: {
        upaya: "In the Upaya dashboard: Profile → API Key.",
        pickndrop: "Pick & Drop support issues your API key and secret (pnd.bz).",
        hello_service: "Hello Service Nepal issues your API key and secret on request.",
      },
      simulated: "Test courier",
      routingEmpty:
        "No rules yet. With only one courier ready, every parcel goes to it; with more, add a rule for each area.",
      ruleTo: "to",
      removeRule: "Remove rule",
    },
    title: "Courier accounts",
    lead: "Connect couriers, route parcels by area and import their delivery rates. Several couriers can be active at once.",
    catalogueTitle: "Couriers",
    moreTitle: "More Nepal couriers",
    moreBody:
      "Coming next. Booking and tracking open once each connection is built and your courier account is linked.",
    connected: "Connected",
    notConnected: "Not connected",
    bookable: "Can book",
    notBookable: "Can't book yet",
    connect: "Connect",
    saveAccount: "Save account",
    savedTitle: "Courier account saved",
    credentialsTitle: "API credentials",
    credentialsHelp:
      "Write-only: after saving you only see the last 4 characters. Never enter a portal password.",
    credentialStored: "Saved, ends in {last4}",
    scenario: "Simulated journey",
    scenarios: {
      deliver: "Delivered after about a day",
      fail_then_deliver: "One failed attempt, then delivered",
      rto: "Two failed attempts, then returned to you",
    },
    real: {
      polling: "Parcel status updates automatically from the courier every 30 minutes.",
      needsSetup: "Add the API key and pickup point to start sending parcels.",
      mode: "Account",
      modeLive: "Live (real parcels)",
      modeTest: "Test (courier sandbox)",
      fields: {
        api_token: "API token",
        client_id: "Client ID",
        client_secret: "Client secret",
        api_key: "API key",
        api_secret: "API secret",
      },
      ncmTokenHelp: "In the NCM vendor portal: Resources → API Integration → Generate new token.",
      ncmBranch: "Pickup branch",
      ncmBranchHelp: "Your Nepal Can Move branch name as NCM writes it, for example TINKUNE.",
      pathaoKeysHelp:
        "Client ID and secret: Pathao merchant panel → Developer API. Your login is used once to connect and never stored.",
      pathaoConnectedStore: "Connected · pickup store {store}",
      savedKey: "Saved",
      pathaoClientId: "Pathao client ID",
      pathaoClientIdHint: "Enter Pathao client ID",
      pathaoClientSecret: "Pathao client secret",
      pathaoClientSecretHint: "Enter Pathao client secret",
      pathaoUsername: "Pathao username",
      pathaoUsernameHint: "Enter Pathao username",
      pathaoPassword: "Pathao password",
      pathaoPasswordHint: "Enter Pathao password",
    },
    merchantRef: "Courier merchant ID",
    merchantRefHelp: "Optional. Webhook messages naming another merchant are rejected.",
    webhookTitle: "Status updates (webhook)",
    webhookAuth: {
      hmac_per_merchant: "Signed with your own secret",
      secret_per_merchant:
        "Checked with your own secret, and every update is matched to your own parcels",
      path_token_only:
        "No signature from this courier; your private link and parcel checks protect it",
      none: "No webhook: parcel status updates from the courier every 30 minutes",
    },
    webhookPending:
      "The webhook receiver is being connected. Status updates come from tracking checks until then.",
    webhookOnce: "Copy these now. They are shown only once.",
    webhookUrl: "Webhook link",
    webhookSecret: "Signing secret",
    rotateWebhook: "New webhook link",
    testWebhook: "Check the webhook secret",
    testWebhookOk: "The secret and signature check work.",
    routingTitle: "Routing",
    routingLead:
      "Rules are tried from the top. With no matching rule, a store with one courier uses it.",
    addRule: "Add rule",
    ruleName: "Name",
    ruleZone: "Area",
    zones: {
      any: "Anywhere",
      inside_valley: "Inside Kathmandu Valley",
      outside_valley: "Outside Kathmandu Valley",
    },
    ruleCourier: "Courier",
    ratesTitle: "Delivery rates from the courier",
    ratesLead:
      "Preview the courier's rates as a separate delivery setup. Nothing changes until you apply, and you can undo.",
    preview: "Preview rates",
    apply: "Apply",
    undo: "Undo",
    summary: "{add} new, {change} changed, {remove} removed, {same} unchanged",
    applied: "Rates applied to “{name}”",
    undone: "Rate import undone",
    syncQueued: "Fetching rates…",
  },
  returns: {
    title: "Returns and exchanges",
    lead: "Receive returned parcels, inspect each item, decide what goes back to stock and refund or exchange.",
    create: "New return",
    caption: "Returns",
    emptyTitle: "No returns",
    emptyBody: "Customer requests, staff returns and parcels returned by couriers appear here.",
    kind: { return: "Return", exchange: "Exchange", rto: "Returned by courier" },
    state: {
      requested: "Requested",
      approved: "Approved",
      received: "Received",
      inspected: "Inspected",
      refunded: "Refunded",
      closed: "Closed",
      rejected: "Rejected",
    },
    by: { customer: "Customer", staff: "Staff", courier: "Courier" },
    requestedBy: "Requested by",
    orderNumber: "Order number",
    findOrder: "Find order",
    reason: "Reason",
    qty: "Qty",
    approve: "Approve",
    reject: "Reject",
    receive: "Mark received",
    inspect: "Save inspection",
    condition: "Condition",
    conditions: { ok: "Good", damaged: "Damaged" },
    restock: "Back to stock",
    restockNever: "Damaged items are never restocked.",
    refundAmount: "Refund",
    refund: "Refund",
    refundMethod: "Refund to",
    methods: {
      original: "Original payment",
      cash: "Cash",
      bank_transfer: "Bank transfer",
      store_credit: "Store credit",
    },
    exchange: "Create exchange order",
    allStates: "All statuses",
    notRestocked: "Not back in stock",
    closeNoRefund: "Close return (nothing to refund)",
    refundAmountButton: "Refund {amount}",
    itemsBack: "Items coming back",
    notReturnableTitle: "This order can't be returned yet",
    notReturnableBody:
      "Only orders that are with the courier, delivered or completed can be returned. Cancel the order instead if it hasn't been sent.",
    notFound: "No order {number} in this store.",
    creditAmount: "Credit",
    openExchange: "Open the exchange order",
    exchangeItems: "New items",
    exchangePick: "Choose items",
    exchangeChange: "Change items",
    exchangeNone: "Choose the items the customer gets instead.",
    exchangeCredit: "Credit from the returned items",
    exchangeNew: "New items total",
    exchangeToPay: "Customer pays",
    exchangeToRefund: "Refund to customer",
    refundDefault: "Starts at the item value; lower it for damage or a partial refund.",
    dialogTitle: "#{number} · {kind} · {state}",
    exchangeDone: "Exchange order created",
    difference: "Difference {amount}",
    saved: "Return updated",
    created: "Return created",
  },
  invoices: {
    title: "Invoices and receipts",
    lead: "Numbered per store and fiscal year with no gaps. These are not certified tax invoices.",
    caption: "Documents",
    emptyTitle: "No documents yet",
    emptyBody: "Issue an invoice or receipt for an order.",
    issue: "Issue",
    kind: { invoice: "Invoice", receipt: "Receipt", credit_note: "Credit note" },
    issued: "{label} {number} issued",
    existing: "{label} {number} already exists",
    fiscalNote:
      "Fiscal year labels assume 1 Shrawan on 16 July until the Bikram Sambat calendar is verified.",
    columns: {
      number: "Number",
      kind: "Type",
      year: "Fiscal year",
      total: "Total",
      issued: "Issued",
    },
  },
  cod: {
    title: "COD checks",
    lead: "Call customers to confirm cash-on-delivery orders before booking a courier.",
    caption: "COD call tasks",
    emptyTitle: "No calls waiting",
    emptyBody: "Add a call task from an order, or turn on phone codes for COD in order protection.",
    confirmed: "Confirmed",
    declined: "Declined",
    noAnswer: "No answer",
    outcomeSaved: "Saved",
    attempts: "{count} calls",
    state: {
      pending: "To call",
      confirmed: "Confirmed",
      declined: "Declined",
      no_answer: "No answer",
    },
  },
  protection: {
    title: "Order protection",
    lead: "Rules checked on every online order: limits, COD caps and phone codes for COD.",
    rulesTitle: "Rules",
    addRule: "Add rule",
    kind: {
      max_amount: "Largest order amount",
      max_qty: "Most items per order",
      per_phone_period: "Orders per phone in a period",
      cod_cap: "Largest COD amount",
      require_otp: "Phone code for COD",
      require_deposit: "Deposit required",
    },
    message: "Message shown to the customer",
    amount: "Amount",
    count: "Count",
    hours: "Period (hours)",
    perPeriod: "{count} per {hours} hours",
    active: "On",
    smsPendingTitle: "Phone codes can't be sent by SMS yet",
    smsPendingBody:
      "SMS delivery is pending activation. Until an SMS provider is connected, customers can't receive the code, so COD orders under this rule can't be placed online.",
    reliabilityTitle: "Customer delivery record",
    reliabilityBody:
      "Each customer gets a score from your business's own deliveries only: (delivered + 1) ÷ (delivered + 2 × returned-to-you + 2), as a percentage. No score until the first delivery outcome. Other businesses' data is never used.",
  },
} as const;
